import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { GiftComponent } from '../gift/gift.component';
import { CountDownComponent } from '../count-down/count-down.component';
import { FrontPageComponent } from '../front-page/front-page.component';
import { GreetingComponent } from '../greeting/greeting.component';
import { MessageComponent } from '../message/message.component';
import { PhraseComponent } from '../phrase/phrase.component';
import { PlacesComponent } from '../places/places.component';

@Component({
  selector: 'app-home',
  imports: [CommonModule, GiftComponent, CountDownComponent, FrontPageComponent, GreetingComponent, MessageComponent, PhraseComponent, PlacesComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  isMobile: boolean = false;

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    const width = window.innerWidth;
    this.isMobile = width <= 600; // Aquí puedes ajustar el tamaño máximo permitido para pantalla móvil
  }
  
  
}
